import { useContext } from 'react';

import { StoreAction } from '../store/questionnaire/questionnaire';
import { QuestionnaireStore } from '../store';

const useQuestionnaireStore = (): StoreAction =>
  useContext(QuestionnaireStore.QuestionnaireContext);

export default useQuestionnaireStore;
